const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

export function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function randomString(length: number = 10): string {
  let text = "";
  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}

export enum KeyType {
  Enter = "Enter",
  Backspace = "Backspace",
  Delete = "Delete",
  Tab = "Tab",
  I = "i",
  B = "b",
  K = "k",
  Dash = "-",
  Escape = "Escape",
  AngleBracketClose = ">",
  ArrowUp = "ArrowUp",
  ArrowDown = "ArrowDown",
  ArrowLeft = "ArrowLeft",
  ArrowRight = "ArrowRight",
  Space = " ",
  Ctrl = "Control",
  CurlyBracketOpen = "{",
  BackTick = "`",
  CloseBracket = ")",
  OpenBracket = "(",
  CloseSquareBracket = "]",
  CapitalP = "P",
  CapitalD = "D",
  CapitalO = "O",
  Line = "|",
  Slash = "/",
  Three = "3",
  Colon = ":",
  Plus = "+",
}

export enum MouseButtonType {
  Left = 0,
  Middle = 1,
  Right = 2,
}
